import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import gsap from 'gsap'
import GUI from 'lil-gui'
import { STLExporter } from 'three/examples/jsm/exporters/STLExporter.js'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'

// tekst diameter


/**
 * Debug
 */
const gui = new GUI()

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')



// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color('#000000')

const params = { background: '#000000' }

// Voeg een lichtbron toe zodat de bol ronding krijgt
const light = new THREE.DirectionalLight('background', 1)
light.position.set(100, 100, 100)
scene.add(light)

const ambient = new THREE.AmbientLight('background', 1)
scene.add(ambient)

/**
 * Object
 */
const geometry = new THREE.SphereGeometry(125,300,300)
const material = new THREE.MeshStandardMaterial({ color: '#fff1c6' })
const mesh = new THREE.Mesh(geometry, material)
scene.add(mesh)



const diameterDisplay = document.getElementById('diameter-display');

const params1 = { radius: 125 }; // beginwaarde
gui.add(params1, 'radius')
    .min(1)
    .max(125)
    .step(0.01)
    .name('Sphere Radius')
    .onChange((value) => {
        // Oude geometrie opruimen
        mesh.geometry.dispose();

        // Nieuwe geometrie aanmaken
        mesh.geometry = new THREE.SphereGeometry(value, 300, 300);

        // Update diameter-display
        const diameter = value * 2;
        diameterDisplay.textContent = `Diameter: ${diameter.toFixed(1)} mm`;
    });



gui.add(mesh, 'visible')

.onChange((value) =>
{
    console.log(value.getHexString())   
})



//stl convert
const exporter = new STLExporter()

params.exportSTL = function() {
    // Clone mesh zodat originele niet verandert
    const meshClone = mesh.clone()

    // Schaalfactor: 1 unit = 1 mm (pas aan indien nodig)
    const scaleFactor = 1
    meshClone.scale.multiplyScalar(scaleFactor)

    const stlData = exporter.parse(meshClone)

    const blob = new Blob([stlData], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = 'model_mm.stl'
    link.click()

    URL.revokeObjectURL(url)
}




/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 10000)
camera.position.x = 150
camera.position.y = 150

camera.position.z = 225
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const radius = 400; // afstand van camera tot bol
const speed = 0.1;  // draai-snelheid

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update()

    

    // Render
    renderer.render(scene, camera)
 
    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
    
}

tick()


//camera draaien 

// Easter egg
const messages = [
    'You are now in the matrix!',
    'Reality has been overwritten.',
    'Color sync achieved.',
    'Welcome to the void.',
    'Everything matches now…'
]

function checkMatrix() {
    const bg = scene.background.getHexString()
    const mesh = material.color.getHexString()

    if (bg === mesh) {
        const msg = messages[Math.floor(Math.random() * messages.length)]
        console.log(msg)
        alert(msg)
    }
}
// Pak je tekst-element
const headerText = document.getElementById('header-text')
const headerText2 = document.getElementById("diameter-display")

gui.addColor(material, 'color')
.onChange((value) => {
    checkMatrix()
        // Meshkleur updaten
    material.color.set(value)

    // Tekstkleur updaten zodat die mee verandert
    headerText.style.color = '#' + value.getHexString()
    headerText2.style.color = '#' + value.getHexString()
})

gui.addColor(params, 'background')
.onChange((value) => {
    scene.background.set(value)
    checkMatrix()
})

// stl exporter knop
gui.add(params, 'exportSTL').name('Export STL (mm)')


// -----------------------------

